import api from './api';

const paymentService = {
  // Submit manual payment
  // Expected data: { invoice_id, amount, payment_method, transaction_reference }
  // Note: payment_date is auto-set by backend, notes field not supported yet
  submitManualPayment: (data) => {
    return api.post('/api/payments/manual', data);
  },

  // Get invoice payments
  getInvoicePayments: (invoiceId) => {
    return api.get(`/api/payments/${invoiceId}`);
  },

  // Get tenant payments
  getTenantPayments: (tenantId) => {
    return api.get(`/api/payments/tenant/${tenantId}`);
  },

  // Get all payments (for landlords)
  getAllPayments: () => {
    return api.get('/api/payments');
  },

  // Apply credits to a specific invoice
  applyCreditsToInvoice: (invoiceId) => {
    return api.post(`/api/payments/apply-credits/${invoiceId}`);
  },

  // Apply all available credits to all outstanding invoices for a tenant
  applyAllCreditsToTenant: (tenantId) => {
    return api.post(`/api/payments/apply-all-credits/${tenantId}`);
  },

  // Void a payment
  voidPayment: (id, reason) => {
    return api.post(`/api/payments/${id}/void`, { reason });
  },

  // Initiate M-Pesa STK Push payment
  initiateMpesaPayment: (invoiceId, phoneNumber, amount) => {
    return api.post(`/api/payments/mpesa/initialize?invoice_id=${invoiceId}&phone_number=${phoneNumber}${amount ? `&amount=${amount}` : ''}`);
  },

  // Query M-Pesa STK Push payment status
  queryMpesaStatus: (checkoutRequestId) => {
    return api.post(`/api/payments/mpesa/query?checkout_request_id=${checkoutRequestId}`);
  },

  // Get unmatched C2B payments
  getUnmatchedPayments: () => {
    return api.get('/api/payments/unmatched/list');
  },

  // Apply unmatched payment to an invoice
  applyUnmatchedPayment: (unmatchedId, invoiceId) => {
    return api.post(`/api/payments/unmatched/${unmatchedId}/apply`, { invoice_id: invoiceId });
  },
};

export default paymentService;
